export default __webpack_public_path__ + "static/media/ttt.48d927ef.jfif";